import * as React from 'react';

export const STAFF_TEXT_PROMO_TITLE = 'Just text a photo to create a submission.';
export const STAFF_TEXT_PROMO_DETAIL = 'Register your phone number to get started.';
export const STAFF_TEXT_PROMO_ACTION = 'Get started';

export interface IStaffTextCreatePromoProps {
  href: string;
  onNavigate: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  onDismiss: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const StaffTextCreatePromo = ({ href, onNavigate, onDismiss }: IStaffTextCreatePromoProps) => (
  <div className="create-options-dropdown__promo">
    <a className="create-options-dropdown__promo-link" href={href} onClick={onNavigate}>
      <span className="create-options-dropdown__promo-icon">
        <img src="/assets/staff-text-phone.svg" alt="" width={17} height={17} />
      </span>
      <span className="create-options-dropdown__promo-copy">
        <span className="create-options-dropdown__promo-title">{STAFF_TEXT_PROMO_TITLE}</span>
        <span className="create-options-dropdown__promo-detail">{STAFF_TEXT_PROMO_DETAIL}</span>
        <span className="create-options-dropdown__promo-action">
          {STAFF_TEXT_PROMO_ACTION} <span aria-hidden="true">→</span>
        </span>
      </span>
    </a>
    <button
      type="button"
      className="create-options-dropdown__promo-dismiss"
      aria-label="Dismiss Text a Photo"
      onClick={onDismiss}
    >
      <img src="/assets/staff-text-dismiss.svg" alt="" width={14} height={14} />
    </button>
  </div>
);

export default StaffTextCreatePromo;
